import Evaluation from "../Components/UI/Evaluation";
import { Trans, useTranslation } from "react-i18next";
import Paywall from "../Components/UI/Paywall";
import { useState } from "react";
import CompareEvaluation from "../Components/UI/CompareEvaluation";

function ConclusionPage (props) {
    const { t } = useTranslation();

    //Paywall
    const [paywall, setPaywall] = useState();
    const [evaluation, setEvaluation] = useState(false);

    function onClickHandler() {
        setPaywall(true);
    }

    function onExitHandler() {
        setPaywall(false);
    }

    //Compare results
    const [button, setButton] = useState(true);

    function showButton (bool) {
        setButton(bool);
    }

    function showCompareEvaluationHandler () {
        setPaywall(false);
        setEvaluation(true);
    }

    //average Results
    const [averageResults, setAverageResults] = useState({});

    function getAverageResults (results) {
        setAverageResults(results);
    }

    return (
        <div className="container-md case">
            <h2>5. {t("conclusion")}</h2>
            <div className="row gap-1">
                <Trans>
                <div className="col-md p-0" style={{width: "fit-content"}}>
                    <p>
                        {t("conclusion_text1")} <br/>
                        {t("conclusion_text2")} <br/>
                        {t("conclusion_text3")} <br/>
                        {t("conclusion_text4")}
                    </p>
                </div>
                </Trans>
                <div className="col-md-5 p-0" style={{justifyContent: "center", display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <Evaluation button={button} onClick={onClickHandler} penAndPaperScore={props.penAndPaperScore} penAndPaperSeconds={props.penAndPaperSeconds} penAndPaperMinutes={props.penAndPaperMinutes} deductionsScore={props.deductionsScore} deductionsSeconds={props.deductionsSeconds} deductionsMinutes={props.deductionsMinutes} kpisScore={props.kpisScore} kpisSeconds={props.kpisSeconds} kpisMinutes={props.kpisMinutes} />
                </div>
                {paywall && <Paywall onExit={onExitHandler} showButton={showButton} showEvaluation={showCompareEvaluationHandler} getAverageResults={getAverageResults} penAndPaperScore={props.penAndPaperScore} penAndPaperSeconds={props.penAndPaperSeconds} penAndPaperMinutes={props.penAndPaperMinutes} deductionsScore={props.deductionsScore} deductionsSeconds={props.deductionsSeconds} deductionsMinutes={props.deductionsMinutes} kpisScore={props.kpisScore} kpisSeconds={props.kpisSeconds} kpisMinutes={props.kpisMinutes}/>}
            </div>
            {evaluation && <CompareEvaluation averageResults={averageResults} penAndPaperScore={props.penAndPaperScore} penAndPaperSeconds={props.penAndPaperSeconds} penAndPaperMinutes={props.penAndPaperMinutes} deductionsScore={props.deductionsScore} deductionsSeconds={props.deductionsSeconds} deductionsMinutes={props.deductionsMinutes} kpisScore={props.kpisScore} kpisSeconds={props.kpisSeconds} kpisMinutes={props.kpisMinutes}/>}
            <p style={{fontSize: "25px", textAlign: "center", marginTop: "2rem", fontWeight: 500}}>{t("conclusion_text6")}</p>
            
        </div>
    );
}

export default ConclusionPage